export const ItemTypes = {
  SKILL: "skill",
  EMPLOYEE: "employee",
  JOB: "job",
  APPLICANT: "applicant",
};
